import { FaGraduationCap, FaBriefcase, FaInstagram, FaCode, FaChalkboardTeacher } from 'react-icons/fa';
import './index.css';

const highlights = [
  { Icon: FaGraduationCap, value: 'B.Tech 2026', label: 'Graduate, VVIT Guntur' },
  { Icon: FaBriefcase, value: '5 Months', label: 'Chegg SME Experience' },
  { Icon: FaInstagram, value: '6,000+', label: 'Instagram Followers' },
  { Icon: FaCode, value: '15+', label: 'Web Projects Built' },
  { Icon: FaChalkboardTeacher, value: '20+', label: 'Python Problems Taught' },
];

const Highlights = () => (
  <section className="highlights">
    <div className="highlights-grid">
      {highlights.map(({ Icon, value, label }) => (
        <div key={label} className="highlight-card glass-card">
          <Icon className="highlight-icon" />
          <span className="highlight-value">{value}</span>
          <span className="highlight-label">{label}</span>
        </div>
      ))}
    </div>
  </section>
);

export default Highlights;
